import _isNil from "lodash/isNil";
import { HTMLContent } from '@datacamp/le-shared-components';
import * as React from 'react';
import showdown from 'showdown';
import { jsx as ___EmotionJSX } from "@emotion/react";
const converter = new showdown.Converter();
converter.setOption('openLinksInNewWindow', true);
converter.setOption('tables', true);
const removeWrappingParagraph = markdown => _isNil(markdown) ? markdown : markdown.replace(/^(?:<p>)?(.*?)(?:<\/p>)?$/, '$1');
const MarkdownContent = _ref => {
  let {
    markdown
  } = _ref;
  return ___EmotionJSX(HTMLContent, {
    html: removeWrappingParagraph(converter.makeHtml(markdown))
  });
};
export { converter };
export default MarkdownContent;